module.exports = __webpack_public_path__ + "static/media/fly0261.9de68e9d.webp";